import React from "reactn";
import "./RequestInfo.css";
import "./baseModal/fieldComponents/fieldComponent.css";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { addWeeks, format, isSameDay, isBefore, isAfter } from "date-fns";
import { addDays, addMonths } from "date-fns/esm";
import { zonedTimeToUtc } from "date-fns-tz";
import { toast } from "react-toastify";
import _, { toInteger } from "lodash";
import { ModalTemplate, ModalFields } from "../UI/modalComponents";
import BaseModal from "./baseModal/BaseModal";
import {
  STRING_INPUT,
  IMAGE_DROPDOWN,
  SWITCH,
  DROPDOWN,
  DATE_PICKER,
  GET_HTML
} from "./baseModal/FieldTypes";
import { notEmptyString, validateEmail } from "./baseModal/validators";
import Title from "./baseModal/fieldComponents/Title.jsx";
import DatePicker from "react-datepicker";
import { BLUE_BUTTON, WHITE } from "./baseModal/colours";
import { TimerSharp } from "@material-ui/icons";

class AddDropInPlan extends React.PureComponent {
  constructor(props) {
    super(props);
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log(tz);
    this.state = {
      startDate: zonedTimeToUtc(this.global.program.program_start, tz),
      endDate: null,
      enableSpecificDates: false,
      available_days: [],
      drop_in_days: [],
      total_price: 0,
      isDescriptionEnabled: false,
      description: "",
      isTaxEnabled: false,
      isCapEnabled: false,
      taxInfo: [],
      planCap: "",
      startTime: "",
      endTime: "",
      linkedSemesterPlan: undefined,
      premium: 0,
      showPriceSuggestion: false,
      suggestedPrice: null,
      priceSuggestionReason: "",
      isCalculatingSuggestion: false,
      activeSuggestionField: null
    };
  }

  requestTour = async e => {
    e.preventDefault();
  };

  componentDidMount() {
    this.getTotalDays();
    
    const startTime = this.global.program.timing[0];
    const startHour = parseInt(startTime.split('.')[0]);
    const startMinute = startTime.split('.').length === 2 ? parseFloat(`0.${startTime.split('.')[1]}`) * 60 : 0;
    const endTime = this.global.program.timing[1];
    const endHour = parseInt(endTime.split('.')[0]);
    const endMinute = endTime.split('.').length === 2 ? parseFloat(`0.${endTime.split('.')[1]}`) * 60 : 0;

    let startTimeString;
    if (startHour >= 13) {
      startTimeString = `${startHour - 12}:`;
      if (startMinute < 10) {
        startTimeString += `0${startMinute}PM`;
      } else {
        startTimeString += `${startMinute}PM`;
      }
    } else {
      startTimeString = `${startHour}:`;
      if (startMinute < 10) {
        startTimeString += `0${startMinute}AM`;
      } else {
        startTimeString += `${startMinute}AM`;
      }
    }

    let endTimeString;
    if (endHour >= 13) {
      endTimeString = `${endHour - 12}:`;
      if (endMinute < 10) {
        endTimeString += `0${endMinute}PM`;
      } else {
        endTimeString += `${endMinute}PM`;
      }
    } else {
      endTimeString = `${endHour}:`;
      if (endMinute < 10) {
        endTimeString += `0${endMinute}AM`;
      } else {
        endTimeString += `${endMinute}AM`;
      }
    }

    this.setState({
      startTime: startTimeString,
      endTime: endTimeString
    });
  }

  getTotalDays() {
    const days = {
      1: "Monday",
      2: "Tuesday",
      3: "Wednesday",
      4: "Thursday",
      5: "Friday",
      6: "Saturday",
      0: "Sunday"
    };
    let startDate = new Date(this.global.program.program_start);
    let endDate;

    if (this.global.program.isRecurring) {
      endDate = addMonths(startDate, 24); // This is for recurring programs (by default we display 2 years / 24 months)
    } else {
      endDate = addWeeks(startDate, this.global.program.number_of_weeks);
    }
    let dayCount = 0;
    let okdays = [];

    let date = startDate;
    while (isBefore(date, endDate)) {
      console.log(date);
      if (this.global.program.closure_timeframe[0] &&
        this.global.program.closure_timeframe[1] &&
        isAfter(date, new Date(this.global.program.closure_timeframe[0]) && 
        isBefore(date, new Date(this.global.program.closure_timeframe[1])))) {
        date = addDays(date, 1);
        continue;
      }
      let isClosed = false;
      for (let day of this.global.program.closure_dates) {
        if (isSameDay(day, date)) {
          isClosed = true;
          break;
        }
      }

      if (isClosed) {
        date = addDays(date, 1);
        continue;
      }
      
      if (this.global.program.days_of_week[days[date.getDay()]]) {
        okdays.push(date);
        dayCount++;
      }

      date = addDays(date, 1);
    }
   
    this.setState({ dayCount: dayCount, available_days: okdays, drop_in_days: okdays });
  }

  async savePlan() {
    if (!this.global.organizationInfo.stripeId) {
      toast.error("Denied. Please connect your Bank Account first");
      return;
    }
    if (!this.state.total_price || this.state.total_price <= 0) {
      toast.error("Please enter a valid price.");
      return;
    }
    if (this.state.isTaxEnabled && this.state.taxInfo.length == 0) {
      toast.error("Please select a tax plan, otherwise disable taxes");
      return;
    }

    const obj = { ...this.state, type: "Drop-In" };
    delete obj.available_days;

    if (!this.state.addOn) {
      delete obj.addOn;
      delete obj.addOnItems;
    }

    if (
      this.global.program.total_spots &&
      this.global.program.total_spots < parseInt(obj.planCap)
    ) {
      obj.planCap = this.global.program.total_spots;
    } else {
      if (parseInt(obj.planCap) > 200) {
        obj.planCap = 200;
      }
    }
    // obj.total_price = parseFloat(obj.total_price).toFixed(2);

    const ep = `${process.env.REACT_APP_API}/partners/stripe/add_products`;
    try {
      const res = await axios.post(ep, {
        ...obj,
        parent: "Program",
        name: this.global.program.program_name,
        type: "One-Time",
        product: this.global.program.product_stripe,
      });
      this.setGlobal(
        {
          program: {
            ...this.global.program,
            product_stripe: res.data.data.product,
            plans: [
              ...this.global.program.plans,
              {
                ...obj,
                id: this.global.program.plans.length,
                prodId: res.data.data.id,
              }
            ]
          }
        },
        () => {
          this.dispatch.saveProgram();
        }
      );
      this.props.onClose();
    } catch {
      toast.error("Could not add pricing plan.");
    }
  }

  semesterLinkOptions = () => {
    const semesterPlans = this.global.program.plans.filter(plan => {
      console.log("PLAN:", plan);
      try {
        if (typeof plan === "string") {
          const parsedPlan = JSON.parse(plan.trim());
          return (parsedPlan.type === "Semester" || !parsedPlan.type) && !parsedPlan.archived;
        }
      } catch (error) {
        console.error(error);
        console.log("Error Plan:", plan);
        return false;
      }

      return (plan.type === "Semester" || !plan.type) && !plan.archived;
    });
    return semesterPlans.map(plan => {
      let parsedPlan = plan;
      if (typeof plan === "string") {
        try {
          parsedPlan = JSON.parse(plan.trim());
        } catch (error) {
          console.error(error);
          console.log("Error Plan:", plan);
        }
      }

      const price = parseFloat(parsedPlan.total_price || parsedPlan.tuition_rate).toFixed(2);
      const name = (parsedPlan.type || "Recurring") + 
        (parsedPlan.description 
          ? `: ${parsedPlan.description.substring(0, 7)}...`
          : "");
      
      return {
        value: parsedPlan.id,
        text: `${name} | $${price}`
      }
    });
  }

  taxesOptions = () => {
    //const global_organization = [JSON.parse(this.global.organizationInfo.stripeTaxId)]
    const global_organization = this.global.organizationInfo.stripeTaxId;
    console.log("global_organization", global_organization);
    const DATA = [];
    for (let i = 0; i < global_organization.length; i++) {
      DATA.push(JSON.parse(global_organization[i]));
    }
    console.log("DATA", DATA);

    return [
      ...DATA.map((e, i) => ({
        value: i,
        text: e.display_name + " " + e.jurisdiction + e.percentage + "%"
      }))
    ];
  };

  calculatePriceSuggestion = async (fieldName) => {
    this.setState({ 
      isCalculatingSuggestion: true,
      activeSuggestionField: fieldName,
      showPriceSuggestion: true, 
      suggestedPrice: 0,
      priceSuggestionReason: "Suggesting..." 
    });
    
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/partners/programs/price-suggestion`, {
        partnerId: this.global.organizationInfo.id,
        programType: "Drop-In",
        programName: this.global.program.program_name,
        programCategory: this.global.program.program_category,
        dayCount: 1, 
        constraints: {
          minPrice: 0,
          maxPrice: 1000
        },
        additionalParams: {
          linkedSemesterPlan: this.state.linkedSemesterPlan,
          premium: this.state.premium
        }
      });

      if (response.data && response.data.success && response.data.data) {
        const suggestion = response.data.data;
        this.setState({
          suggestedPrice: suggestion.suggestedPrice,
          priceSuggestionReason: suggestion.reasoning,
          isCalculatingSuggestion: false
        });
      } else {
        this.setState({
          suggestedPrice: 0,
          priceSuggestionReason: "Unable to generate price suggestion",
          isCalculatingSuggestion: false
        });
      }
    } catch (error) {
      console.error('Error calculating price suggestion:', error);
      this.setState({
        suggestedPrice: 0,
        priceSuggestionReason: "Unable to generate price suggestion",
        isCalculatingSuggestion: false
      });
    }
  };

  // Add method to use suggested price
  useSuggestedPrice = () => {
    if (this.state.suggestedPrice) {
      this.setState({
        total_price: this.state.suggestedPrice,
        showPriceSuggestion: false,
        activeSuggestionField: null
      });
    }
  };

  // Add method to dismiss suggestion
  dismissSuggestion = () => {
    this.setState({
      showPriceSuggestion: false,
      activeSuggestionField: null
    });
  };

  getBaseModalFields() {
    const pricing = {
      type: STRING_INPUT,
      data: {
        name: "Drop-in Price",
        required: true,
        type: "number",
        handleChange: e => {
          if (e.target.value === "") {
            this.setState({
              total_price: null
            });
            return;
          }
  
          this.setState({
            total_price: parseFloat(e.target.value)
          });
        },
        value: this.state.total_price,
        styles: {
          width: "63%"
        },
        wrapperStyles: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        suggestion: this.state.activeSuggestionField === 'total_price' ? {
          price: this.state.suggestedPrice,
          reason: this.state.priceSuggestionReason,
          isLoading: this.state.isCalculatingSuggestion,
          onUse: this.useSuggestedPrice,
          onDismiss: this.dismissSuggestion
        } : null,
        onFocus: () => {
          if (!this.state.suggestedPrice && !this.state.isCalculatingSuggestion) {
            this.calculatePriceSuggestion('total_price');
          }
        },
        onBlur: () => {
          setTimeout(() => {
            if (this.state.activeSuggestionField === 'total_price') {
              this.setState({
                showPriceSuggestion: false,
                activeSuggestionField: null
              });
            }
          }, 200);
        }
      },
      validators: { validateSubmit: () => this.state.total_price !== null }
    };

    const addDescription = {
      type: SWITCH,
      data: {
        name: "Add Description",
        checked: this.state.isDescriptionEnabled,
        isDisabled: false,
        handleClick: () => {
          this.setState({
            isDescriptionEnabled: !this.state.isDescriptionEnabled
          });
        }
      }
    };

    const description = {
      type: STRING_INPUT,
      data: {
        name: "Description",
        required: false,
        info: "Max 32 characters",
        maxLength: 32,
        handleChange: e => {
          this.setState({
            description: e.target.value
          });
        },
        value: this.state.description
      }
    };

    const enableSpecificDropInDates = {
      type: SWITCH,
      data: {
        name: "Enable Selecting Specific Drop-In Dates",
        isDisabled: false,
        wrapperStyles: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        checked: this.state.enableSpecificDates,
        handleClick: e => {
          if (e.target.checked) {
            this.setState({
              enableSpecificDates: true,
              drop_in_days: []
            });
          } else {
            this.setState({
              enableSpecificDates: false,
              drop_in_days: this.state.available_days
            });
          }
        }
      }
    };

    const selectDropInDates = {
      type: DATE_PICKER,
      data: {
        name: "Select Drop-in Dates",
        isDisabled: false,
        placeHolder: "Select Dates",
        minDate: new Date(this.state.startDate),
        dateFormat: "MMMM d, yyyy",
        handleChange: date => {
          let wasSelected = false;
          for (let day of this.state.drop_in_days) {
            if (isSameDay(day, date)) {
              wasSelected = true;
            }
          }

          if (wasSelected) {
            this.setState({drop_in_days: this.state.drop_in_days.filter((day) => !isSameDay(day, date))});
          } else {
            this.setState({drop_in_days: [...this.state.drop_in_days, date]})
          }
        },
        filterDate: date => {
          for (let day of this.state.available_days) {
            if (isSameDay(day, date)) {
              return true;
            }
          }
          return false;
        },
        selectedDates: this.state.drop_in_days,
        inline: true,
        disabledKeyboardNavigation: true
      },
      validators: { validateSubmit: () => this.state.drop_in_days.length !== 0}
    }

    const EnableTaxes = {
      type: SWITCH,
      data: {
        name: "Enable Taxes",
        isDisabled: false,
        checked: this.state.isTaxEnabled,
        wrapperStyles: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        handleClick: e =>
          this.setState({
            isTaxEnabled: e.target.checked,
            taxInfo: []
          })
      }
    };

    const linkSemesterPlan = {
      type: DROPDOWN,
      data: {
        name: "Link Semester Plan",
        placeholder: "Do not link a Semester Plan",
        value: this.state.linkedSemesterPlan ? this.state.linkedSemesterPlan.id : undefined,
        required: false,
        styles: {
          width: "63%"
        },
        wrapperStyles: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        handleChange: e => {
          const planId = e.target.value;
          if (planId === "") {
            this.setState({
              linkedSemesterPlan: undefined,
              total_price: 0
            });
            return;
          }
          const plan = JSON.parse(this.global.program.plans.filter(plan => parseInt(JSON.parse(plan).id) === parseInt(planId)));
          if (this.global.program.isRecurring) {
            switch (plan.billing_cycle) {
              case "month":
                this.setState({
                  linkedSemesterPlan: plan,
                  total_price: parseFloat(plan.tuition_rate) / (4 * plan.days_per_week)
                });
                break;
              case "bi-week":
                this.setState({
                  linkedSemesterPlan: plan,
                  total_price: parseFloat(plan.tuition_rate) / (2 * plan.days_per_week)
                });
                break;
              case "week":
                this.setState({
                  linkedSemesterPlan: plan,
                  total_price: parseFloat(plan.tuition_rate) / plan.days_per_week
                });
                break;
            }
          } else {
            this.setState({ 
              linkedSemesterPlan: plan,
              total_price: plan.total_price / this.state.dayCount
            });
          }
        },
        choices: this.semesterLinkOptions()
      }
    };

    const dropInPremium = {
      type: STRING_INPUT,
      data: {
        name: "Premium (%)",
        isDisabled: false,
        placeholder: "Enter a percentage",
        info: "(Max 100%)",
        type: "number",
        wrapperStyles: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        value: this.state.premium,
        handleChange: e => {
          let value = e.target.value;
          while (parseFloat(value) > 100) {
            value = value.substring(0, value.length-1);
          }

          this.setState({ premium: value });
        }
      }
    };
    //if (this.state.isTaxEnabled) {
    const selectTaxes = {
      type: DROPDOWN,
      data: {
        name: "Tax Plan",
        required: false,
        placeholder: "Please Select" /* 
        value: this.state.taxInfo, */,
        styles: {
          width: "63%"
        },
        wrapperStyles: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        handleChange: e => {
          const item = JSON.parse(
            this.global.organizationInfo.stripeTaxId[e.target.value]
          );
          this.setState({
            taxInfo: [
              {
                id: item.id,
                percentage: item.percentage,
                jurisdiction: item.jurisdiction,
                display_name: item.display_name,
                description: item.description
              }
            ]
          });
        },
        choices: this.taxesOptions()
      } /* ,
      validators: { validateSubmit: () => this.state.programs_picked.length !== 0 } */
    };
    //   return [
    //     descriptionInput,
    //     emailInput,
    //     addsonFee,
    //     /* enrollmentEnable, */ //Hidden switch
    //     /* enableDropIns, */ //Hidden switch
    //     EnableTaxes,
    //     selectTaxes
    //   ];
    // }

    const AddCap = {
      type: SWITCH,
      data: {
        name: "Enable Drop-In Cap",
        isDisabled: false,
        checked: this.state.isCapEnabled,
        wrapperStyles: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        handleClick: e => {
          if (e.target.checked) {
            this.setState({
              isCapEnabled: true
            });
          } else {
            this.setState({
              isCapEnabled: false,
              planCap: ""
            });
          }

        }
      }
    };

    const PlanCap = {
      type: STRING_INPUT,
      data: {
        type: "number",
        name: this.global.program.total_spots
          ? `Plan Cap (Max: ${this.global.program.total_spots})`
          : "Plan Cap",
        required: false,
        placeholder: "Enter Cap",
        styles: {
          width: "63%"
        },
        wrapperStyles: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        handleChange: e => {
          this.setState({
            planCap: e.target.value
          });
        }
      }
    };

    const fields = [];

    fields.push(linkSemesterPlan);
    fields.push(pricing);
        
    if (this.state.linkedSemesterPlan) {
      fields.push(dropInPremium);
    }

    fields.push(addDescription);
    if (this.state.isDescriptionEnabled) {
      fields.push(description);
    }

    fields.push(enableSpecificDropInDates)
    if (this.state.enableSpecificDates) {
      fields.push(selectDropInDates);
    }

    fields.push(EnableTaxes);
    if (this.state.isTaxEnabled) {
      fields.push(selectTaxes);
    }
    fields.push(AddCap);
    if (this.state.isCapEnabled) {
      fields.push(PlanCap);
    }

    return fields;
  }

  getBaseModalButtons = () => {
    const debounceSavePlan = _.debounce(_ => this.savePlan(), 2000, {
      leading: true,
      trailing: false
    });
    const addButton = {
      name: "Submit",
      buttonColour: BLUE_BUTTON,
      textColour: WHITE,
      validatorKey: "validateSubmit",
      handleClick: e => {
        e.preventDefault();
        debounceSavePlan();
      }
    };

    return [addButton];
  };

  getBaseModalProps = () => {
    return {
      title: "Pricing Plan",
      fields: this.getBaseModalFields(),
      buttons: this.getBaseModalButtons(),
      handleClose: this.props.onClose,
      height: "65vh",
      midSectionHeight: "49vh"
    };
  };

  render() {
    console.log("this.state", this.state);
    return <BaseModal {...this.getBaseModalProps()} />;
  }
}

export default withRouter(AddDropInPlan);
